import api from '../api';

const authServiceHost = window.PAYBIS_API_HOST;

export const deletePasskey = id => {
  return api.delete(`${authServiceHost}/public/authentication-service/v1/passkeys/${id}`);
};

export const getUserPasskeyList = () => {
  return api.get(`${authServiceHost}/public/authentication-service/v1/passkeys`);
};

export const fetchAttestationOptions = () => {
  return api.post(`${authServiceHost}/public/authentication-service/v1/attestation/options`);
};

export const registerUsingPasskey = cco => {
  return api.post(`${authServiceHost}/public/authentication-service/v1/attestation`, cco);
};

export const fetchAssertionOptions = ()=> {
  return api.post(`${authServiceHost}/public/authentication-service/v1/assertion/options`);
};
